module.exports = __webpack_public_path__ + "static/media/arrow-right.962bd76b.svg";